import { Box, Stack } from '@mui/material';
import React, { useState } from 'react';
import { getChatAgentHostUrl } from '../../../constants/chatAgentConstants';
import { useTranslation } from '../../../hooks/useTranslation';
import Button from '../Button/Button';
import Text from '../Text/Text';
import StyledCodeSnippet from './StyledCodeSnippet';

interface CodeSnippetProps {
  appId: string;
  publicKey: string;
  host?: string;
}

const CodeSnippet: React.FC<CodeSnippetProps> = ({
  appId,
  publicKey,
  host = getChatAgentHostUrl(),
}) => {
  const { t } = useTranslation();
  const [copied, setCopied] = useState(false);

  const codeSnippet = `<script src="${host}/chatbot.js"></script>
<script>
  DCInnovationChatInit({
    appId: '${appId}',
    publicKey: '${publicKey}',
    host: '${host}',
    parent: window.location.origin
  });
</script>`;

  const handleCopyCode = async () => {
    try {
      await navigator.clipboard.writeText(codeSnippet);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error('Failed to copy code:', err);
    }
  };

  return (
    <Stack spacing="1rem" width="100%">
      <Text type="body2">{t('1. Copy the code snippet.')}</Text>
      <Text type="body2">
        {t('2. Add it to your website custom JavaScript section.')}
      </Text>
      <Text type="body2">{t('3. Test it.')}</Text>
      <StyledCodeSnippet>
        <Box component="pre">
          <code>{codeSnippet}</code>
        </Box>
      </StyledCodeSnippet>
      <Button
        onClick={handleCopyCode}
        size="medium"
        type="button"
        disabled={false}
        color="primary"
        variant="outlined"
        style={{ backgroundColor: 'white' }}
      >
        {copied ? t('Copied!') : t('Copy Code Snippet')}
      </Button>
    </Stack>
  );
};

export default CodeSnippet;
